import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { MY_OFFERS } from 'shared/constants/links';

export const StartBlock: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['textblock']}>
          <div className={styles['title']}>Продвижение на Циан</div>
          <div className={styles['subtitle']}>Новые возможности для быстрой сделки</div>
          <div className={styles['btn']}>
            <Theme theme="onOverlay">
              <LinkButton
                fullWidth
                href={MY_OFFERS}
                target="_blank"
                theme="fill_secondary"
                size={device === 'desktop' ? 'L' : 'M'}
              >
                Подключить
              </LinkButton>
            </Theme>
          </div>
        </div>
        <div className={styles['image']} />
      </div>
    </div>
  );
};
